import { Action } from 'redux';

import {
  isFilterContentTypeAction,
  isToggleShowWorkbooksAsViewsAction,
} from '../../actions/ContentExplorerFilterActions';

export function showWorkbooksAsViewsReducer(
  previousState: boolean = false,
  action: Action = null
): boolean {
  if (isToggleShowWorkbooksAsViewsAction(action)) {
    if (action.showWorkbooksAsViews !== undefined) {
      return action.showWorkbooksAsViews;
    } else {
      return !previousState;
    }
  } else if (isFilterContentTypeAction(action)) {
    // if we are showing views, make sure that we toggle the 'showWorkbooksAsViews' to on
    if (action.contentTypes.indexOf('view') > -1) {
      // unless we also are showing workbooks, in which case, fall back to default.
      return action.contentTypes.indexOf('workbook') < 0;
    }
    if (action.contentTypes.indexOf('workbook') > -1) {
      return false;
    }
  }

  return previousState;
}
